module.exports = {
  'align': {
    ''        : require('../assetsAdmin/icons/align-left.svg'),
    'center'  : require('../assetsAdmin/icons/align-center.svg'),
    'right'   : require('../assetsAdmin/icons/align-right.svg'),
    'justify' : require('../assetsAdmin/icons/align-justify.svg')
  },
  'background': require('../assetsAdmin/icons/background.svg'),
  'blockquote': require('../assetsAdmin/icons/blockquote.svg'),
  'bold'      : require('../assetsAdmin/icons/bold.svg'),
  'clean'     : require('../assetsAdmin/icons/clean.svg'),
  'code'      : require('../assetsAdmin/icons/code.svg'),
  'code-block': require('../assetsAdmin/icons/code.svg'),
  'color'     : require('../assetsAdmin/icons/color.svg'),
  'direction' : {
    ''        : require('../assetsAdmin/icons/direction-ltr.svg'),
    'rtl'     : require('../assetsAdmin/icons/direction-rtl.svg')
  },
  'float': {
    'center'  : require('../assetsAdmin/icons/float-center.svg'),
    'full'    : require('../assetsAdmin/icons/float-full.svg'),
    'left'    : require('../assetsAdmin/icons/float-left.svg'),
    'right'   : require('../assetsAdmin/icons/float-right.svg')
  },
  'formula'   : require('../assetsAdmin/icons/formula.svg'),
  'header': {
    '1'       : require('../assetsAdmin/icons/header.svg'),
    '2'       : require('../assetsAdmin/icons/header-2.svg')
  },
  'italic'    : require('../assetsAdmin/icons/italic.svg'),
  'image'     : require('../assetsAdmin/icons/image.svg'),
  'indent': {
    '+1'      : require('../assetsAdmin/icons/indent.svg'),
    '-1'      : require('../assetsAdmin/icons/outdent.svg')
  },
  'link'      : require('../assetsAdmin/icons/link.svg'),
  'list': {
    'ordered' : require('../assetsAdmin/icons/list-ordered.svg'),
    'bullet'  : require('../assetsAdmin/icons/list-bullet.svg'),
    'check'   : require('../assetsAdmin/icons/list-check.svg')
  },
  'script': {
    'sub'     : require('../assetsAdmin/icons/subscript.svg'),
    'super'   : require('../assetsAdmin/icons/superscript.svg'),
  },
  'strike'    : require('../assetsAdmin/icons/strike.svg'),
  'underline' : require('../assetsAdmin/icons/underline.svg'),
  'video'     : require('../assetsAdmin/icons/video.svg')
};



// WEBPACK FOOTER //
// ./ui/icons.js